webpackJsonp([21],{

/***/ 1878:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _header_footer_template = __webpack_require__(1879);

var _header_footer_template2 = _interopRequireDefault(_header_footer_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        config: (0, _general.getConfig)(state)
    });
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_header_footer_template2.default);

/***/ }),

/***/ 1879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotLoggedIn = function (_React$PureComponent) {
    (0, _inherits3.default)(NotLoggedIn, _React$PureComponent);

    function NotLoggedIn() {
        (0, _classCallCheck3.default)(this, NotLoggedIn);
        return (0, _possibleConstructorReturn3.default)(this, (NotLoggedIn.__proto__ || (0, _getPrototypeOf2.default)(NotLoggedIn)).apply(this, arguments));
    }

    (0, _createClass3.default)(NotLoggedIn, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.classList.add('sticky');
            document.getElementById('root').classList.add('container-fluid');
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.classList.remove('sticky');
            document.getElementById('root').classList.remove('container-fluid');
        }
    }, {
        key: 'render',
        value: function render() {
            var content = [];

            if (this.props.config.AboutLink) {
                content.push(_react2.default.createElement(
                    'a',
                    {
                        key: 'about_link',
                        id: 'about_link',
                        className: 'footer-link',
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: this.props.config.AboutLink
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'web.footer.about' })
                ));
            }

            if (this.props.config.PrivacyPolicyLink) {
                content.push(_react2.default.createElement(
                    'a',
                    {
                        key: 'privacy_link',
                        id: 'privacy_link',
                        className: 'footer-link',
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: this.props.config.PrivacyPolicyLink
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'web.footer.privacy' })
                ));
            }

            if (this.props.config.TermsOfServiceLink) {
                content.push(_react2.default.createElement(
                    'a',
                    {
                        key: 'terms_link',
                        id: 'terms_link',
                        className: 'footer-link',
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: this.props.config.TermsOfServiceLink
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'web.footer.terms' })
                ));
            }

            if (this.props.config.HelpLink) {
                content.push(_react2.default.createElement(
                    'a',
                    {
                        key: 'help_link',
                        id: 'help_link',
                        className: 'footer-link',
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: this.props.config.HelpLink
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'web.footer.help' })
                ));
            }

            return _react2.default.createElement(
                'div',
                { className: 'inner-wrap' },
                _react2.default.createElement(
                    'div',
                    { className: 'row content' },
                    this.props.children
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row footer' },
                    _react2.default.createElement(
                        'div',
                        { className: 'footer-pane col-xs-12' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            _react2.default.createElement(
                                'span',
                                { className: 'pull-right footer-site-name' },
                                'Mattermost'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            _react2.default.createElement(
                                'span',
                                { className: 'pull-right footer-link copyright' },
                                '\xA9 2015-' + new Date().getFullYear() + ' Mattermost, Inc.'
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'pull-right' },
                                content
                            )
                        )
                    )
                )
            );
        }
    }]);
    return NotLoggedIn;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

NotLoggedIn.propTypes = {

    /*
     * Content of the page
     */
    children: _propTypes2.default.object,

    /*
     * Mattermost configuration
     */
    config: _propTypes2.default.object
};
exports.default = NotLoggedIn;

/***/ })

});


// WEBPACK FOOTER //
// 21.3751a69b03b95d22413a.js